// DP-4478: wording shared by the order's Shipping box and the Manage Shipping
// popup, so both describe an order's shipping state in the same words.

const FRAME_SOURCES = {
  existing_dresden: 'Existing Dresden Frame',
  non_dresden: 'Non-Dresden Frame',
};

export function plural(count, singular, pluralForm = `${singular}s`) {
  return `${count} ${count === 1 ? singular : pluralForm}`;
}

// The line under an item's name. Same composition as Create Shipping Order
// (DP-4473/DP-4519): identically named glasses lines are told apart by the
// glasses type and the frame's shape and colour.
export function itemDetails(item) {
  return [FRAME_SOURCES[item.frame_source], item.glasses_type, item.frame_shape, item.frame_colour]
    .filter(Boolean)
    .join(' · ');
}

// "4 items awaiting shipment" / "4 items shipped" (Figma frames 1573 and 1610).
// The part-shipped wording is not in the design — proposed in DP-4478.
export function shippingTitle(summary) {
  const total = Number(summary.total_items || 0);
  const shipped = Number(summary.shipped_items || 0);
  const pending = Number(summary.pending_items || 0);

  if (total === 0) return 'No items to ship';
  if (shipped === 0) return `${plural(pending, 'item')} awaiting shipment`;
  if (pending === 0) return `${plural(shipped, 'item')} shipped`;

  return `${plural(shipped, 'item')} shipped · ${pending} awaiting shipment`;
}

// "Pending Shipment" before the first label, then the number of labels
// ("3 Separate Shipments" in Figma frame 1610).
export function shippingBadge(summary) {
  const shipments = Number(summary.shipments_count || 0);

  if (shipments === 0) return { text: 'Pending Shipment', variant: 'pending' };
  if (shipments === 1) return { text: '1 Shipment', variant: 'shipped' };

  return { text: `${shipments} Separate Shipments`, variant: 'shipped' };
}
